import { create } from "zustand";

import { TranslatedPath } from "@/types/generic";

interface UsePageTranslationsPaths {
  pageTranslationsPaths: TranslatedPath[];
  setPageTranslationsPaths: (translationsPaths: TranslatedPath[]) => void;
}

export const usePageTranslationsPaths = create<UsePageTranslationsPaths>(
  (set) => ({
    pageTranslationsPaths: [],
    setPageTranslationsPaths: (pageTranslationsPaths) => {
      set(() => ({ pageTranslationsPaths: pageTranslationsPaths }));
    },
  }),
);
